<template>
  <q-btn
    icon="fa fa-file-download"
    label="Download"
    title="Download PDF"
    v-bind="$attrs"
    @click="download"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import notify from '@/components/notify';
import { getTimeZone } from '@/util/time-zone';
import { download } from '../report';

export default defineComponent({
  props: {
    reportId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    download() {
      const formatOptions = {
        branding: false,
        index: false,
        internalNotes: false,
        externalComments: true,
        footer: false,
        timeZone: getTimeZone(),
      };
      download(this.reportId, 'pdf', formatOptions).then(() => {
        notify({
          message: 'Album is being generated, you will receive an in-app notification when it\'s ready to download.',
          timeout: 60000,
          actions: [
            { label: 'Dismiss', color: 'positive' },
          ],
        });
      });
    },
  },
});
</script>
